import {http} from "../http";

export interface Dxa{
    trnRequestType : string;
    PMTCUSTID : string;
    CUSTCIF : string;
    CUSTACC : string;
    BENEFBANKCODE : string;
    BENEFBANKNAME : string;
    BENEFACC : string;
    BENEFBANKTAXID : string;
    BUDGETCLASSCODE : string;
    BUDGETLEVELCODE : string;
    BUDGETLEVELCODENAME: string;
    AMOUNT : number;
    PMTDET : string;
    CUSTACCFORCOM : string;
    COMMAMOUNT : string;
}

export const newMoneyTransferDxa = async (request_data: Dxa): Promise<Dxa> => {
    const { data } = await http.post<Dxa>("moneytransfer/dxa", request_data);
    return data;
};
